export enum LearningObjectStatus {
    idle = "idle",
    inUse = "inUse",
    converting = "converting",
    recognizing = "recognizing",
    transcribing = "transcribing",
    waitingForDownload = "waitingForDownload",
    waitingForRecognition = "waitingForRecognition",
    error = "error"
}

export enum TrialLearningObjectStatus {
    ready = "Ready",
    idle = "Idle",
    waiting = "Please wait",
    error = "Error"
}
